import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";

export function useUserGrowth(fromDate: string, toDate: string) {
  return useQuery({
    queryKey: ["platformAnalytics", "userGrowth", fromDate, toDate],
    queryFn: () =>
      api.getUserGrowth({ from_date: fromDate, to_date: toDate }),
  });
}
